import { render, staticRenderFns } from "./SecondaryDomains.vue?vue&type=template&id=153a6dfb&"
import script from "./SecondaryDomains.vue?vue&type=script&lang=ts&"
export * from "./SecondaryDomains.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports